import { render, staticRenderFns } from "./DsResult.vue?vue&type=template&id=c0e257ce&scoped=true"
import script from "./DsResult.vue?vue&type=script&lang=js"
export * from "./DsResult.vue?vue&type=script&lang=js"
import style0 from "./DsResult.vue?vue&type=style&index=0&id=c0e257ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e257ce",
  null
  
)

export default component.exports